AFRAME.registerComponent('cube-handler', {
    init: function () {
        const el = this.el;

        // Make raycastable
        el.setAttribute('data-raycastable', '');

        // Store original color
        this.originalColor = el.getAttribute('material').color;

        // Hover events
        this.el.addEventListener('mouseenter', () => {
            el.setAttribute('material', 'color', 'yellow');
        });

        this.el.addEventListener('mouseleave', () => {
            el.setAttribute('material', 'color', this.originalColor);
        });

        // Click event
        this.el.addEventListener('click', () => {
            this.showPopup();
            el.setAttribute('material', 'color', 'green');
        });
    },

    showPopup: function () {
        // Remove existing popup if any
        const existingPopup = this.el.querySelector('.popup');
        if (existingPopup) existingPopup.remove();

        // Create popup entity
        const popup = document.createElement('a-plane');
        popup.setAttribute('class', 'popup');
        popup.setAttribute('width', '1');
        popup.setAttribute('height', '0.5');
        popup.setAttribute('position', '0 0.5 0.1'); // Slightly above cube
        popup.setAttribute('material', 'color: white; opacity: 0.9');

        // Create text
        const text = document.createElement('a-text');
        text.setAttribute('value', 'This is a popup');
        text.setAttribute('align', 'center');
        text.setAttribute('position', '0 0.05 0.01');
        text.setAttribute('color', 'black');
        popup.appendChild(text);

        // Create close button
        const closeBtn = document.createElement('a-plane');
        closeBtn.setAttribute('width', '0.2');
        closeBtn.setAttribute('height', '0.1');
        closeBtn.setAttribute('position', '0 -0.15 0.01');
        closeBtn.setAttribute('material', 'color: red');
        closeBtn.setAttribute('text', 'value: X; align: center; color: white');

        closeBtn.addEventListener('click', () => {
            popup.remove();
            this.el.setAttribute('material', 'color', this.originalColor);
        });

        popup.appendChild(closeBtn);
        this.el.appendChild(popup);
    },

    remove: function () {
        // Cleanup: remove any popups when component is removed
        const popup = this.el.querySelector('.popup');
        if (popup) popup.remove();
    }
});